import { Button } from "@mui/joy";
import useDetectIOS from "hooks/useDetectIOS";
import google_logo from "static/image/common/google_logo.png";
import apple_logo from "static/image/common/apple_logo.png";
import { theme } from "styles/theme";
import kakao_logo from "../../static/image/common/kakao_logo.png";

export default function LoginButtonTemplatePromotion({
  loginType,
  action,
  isLoggedIn,
  isLoading,
  widthPx,
  heightPx,
}: {
  loginType: "apple" | "google" | "kakao";
  action: () => void;
  isLoggedIn: boolean;
  isLoading?: boolean;
  widthPx?: number | string;
  heightPx?: number | string;
}) {
  const disabled = isLoading;
  const { isIOS } = useDetectIOS();

  const loginDataByType: {
    [key in "apple" | "google" | "kakao"]: {
      logo?: string;
      buttonText: string;
      backgroundColor: string;
      color: string;
      borderColor?: string;
    };
  } = {
    apple: {
      logo: apple_logo,
      buttonText: "Apple로 시작하기",
      backgroundColor: theme.vars.palette.Surface.Forward,
      color: theme.vars.palette.Content.Strong,
      borderColor: "none",
    },
    google: {
      logo: google_logo,
      buttonText: "Google로 시작하기",
      backgroundColor: theme.vars.palette.Surface.Forward,
      color: theme.vars.palette.Content.Strong,
      borderColor: "none",
    },
    kakao: {
      logo: kakao_logo,
      buttonText: "Kakao로 시작하기",
      backgroundColor: "#FEE500",
      color: theme.vars.palette.Content.Strong,
      borderColor: "none",
    },
  };

  const currentLoginData = loginDataByType[loginType];

  return (
    <Button
      onClick={!disabled ? action : () => {}}
      variant={"Plain"}
      color={"neutral"}
      size="md"
      sx={{
        backgroundColor: currentLoginData.backgroundColor,
        color: currentLoginData.color,
        width: widthPx,
        "@media (min-width: 1024px)": {
          "&:hover:not(.Mui-disabled)": {
            backgroundColor: currentLoginData.backgroundColor,
            color: currentLoginData.color,
            opacity: 0.6,
          },
        },
        "@media (max-width: 1024px)": {
          "&:hover": {
            // 모바일에서 터치 끝나도 hover로 잡는 문제 때문에 hover은 1024 이상에서만 적용
            // ios : 버튼 클릭 후 touchend 해도 hover
            backgroundColor: currentLoginData.backgroundColor,
            color: currentLoginData.color,
          },
        },
        "&:focus": {
          backgroundColor: currentLoginData.backgroundColor,
          color: currentLoginData.color,
        },
        "&:active": {
          backgroundColor: currentLoginData.backgroundColor,
          color: currentLoginData.color,
        },
      }}
      startDecorator={
        <img
          src={currentLoginData.logo}
          alt={"empty"}
          style={{
            width: "20px",
            height: "20px",
            objectFit: "contain",
          }}
        />
      }
    >
      {isLoading ? "로그인 중..." : currentLoginData.buttonText}
    </Button>
  );
}
